import React, {useContext, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import CustomButton from "../../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {printExpeditionList} from "../../../../../../api/expeditionList/print";
import {WMSContext} from "../../../../context/WMSContext";
import pusherClient from "../../../../../../utils/pusherClient";
import {
    ExpeditionListMessageSeverity,
    ExpeditionListMessageType
} from "../../../../../../utils/ExpeditionListMessageType";

ExpeditionListViewItem.propTypes = {
    expeditionList: PropTypes.object.isRequired
};

function ExpeditionListViewItem({expeditionList}) {
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState()

    const documentIsPrintedTimeout = useRef()

    const {preferredPrinter} = useContext(WMSContext)

    const currentExpeditionChannel = pusherClient.subscribe('expeditionList-'+expeditionList.id)

    currentExpeditionChannel.bind(ExpeditionListMessageType.PRINT_MESSAGE, (data) => handleExpeditionListMessage(data))

    const handlePrint = () => {
        setLoading(true)
        printExpeditionList(expeditionList.id, preferredPrinter.documentPrinterId)
        documentIsPrintedTimeout.current = setTimeout(() => {
            setLoading(false)
        }, 5000)
    }

    function handleExpeditionListMessage (data) {
        clearTimeout(documentIsPrintedTimeout.current)
        if (ExpeditionListMessageSeverity.ERROR === data.severity) {
            setLoading(false)
            setErrorMessage(data.message)
        }
        if (ExpeditionListMessageSeverity.SUCCESS === data.severity) {
            setLoading(false)
        }
    }

    return (
        <Grid
            container
            justifyContent={'space-between'}
            flexWrap={'nowrap'}
            alignItems={'center'}
        >
            <Grid container gap={'8px'}>
                <span>{expeditionList.displayedId}</span>
                <span>{expeditionList.name}</span>
            </Grid>

            <Grid container gap={'8px'} justifyContent={'end'} flexWrap={'nowrap'}>
                <a
                    rel={'noopener noreferrer'}
                    target={!loading ? '_blank' : ''}
                    href={!loading ? expeditionList.url : '#'}
                    aria-disabled={loading}
                    style={{textDecoration: "none", width: '100%'}}
                >
                    <CustomButton disabled={loading} fullWidth>
                        <FormattedMessage id={"wms.shipping.expeditionListView.viewButtonLabel"}/>
                    </CustomButton>
                </a>

                <CustomButton
                    onClick={() => handlePrint()}
                    disabled={loading || !preferredPrinter?.documentPrinterId}
                    color={'default'}
                    fullWidth
                >
                    <FormattedMessage id={"wms.shipping.expeditionListView.printButtonLabel"}/>
                </CustomButton>
            </Grid>
        </Grid>
    );
}

export default ExpeditionListViewItem;